import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";



import useApiRequest from "../../../../Hooks/apiReq";
import TitleSection from "../../../../Shared/TitleSection/TitleSection";

import Loader from "../../../../CommonComponets/Loader";
import DateFilterBar from "../../../../CommonComponets/DateFilterBar/DateFilterBar";
import { convertToINRFormat } from "../../../../Utils/INRConvert";
import moment from "moment";
const MyPayoutsOrg = () => {
    const [preFilter, setPreFilter] = useState({});
    const { error, loading, recallRequest, response, sendApiRequest, status } =
        useApiRequest();
    const navigate = useNavigate();
    const [myAllPayouts, setPayouts] = useState([]);
    const GetAssociatePayout = (from, to) => {
        const formattedFromDate = from ? moment(from).format("DD-MM-YYYY") : ""
        const formattedToDate = to ? moment(to).format("DD-MM-YYYY") : ""
        const loggedInUser = JSON.parse(sessionStorage.getItem("loggedInUser"));
        if (JSON.stringify(preFilter) === JSON.stringify({ formattedFromDate, formattedToDate })) {
            toast.warn("You have already selected this date range", {
                toastId: "payouts"
            });
            return;
        }
        const data = {
            AutoId: loggedInUser.AutoID,
            FromDate: formattedFromDate,
            ToDate: formattedToDate,
            LoginToken: loggedInUser.LoginToken,
            AppVersion: loggedInUser?.AppVersion,
            DeviceType: "Web",
            TransactionType: "",
        };
        sendApiRequest(
            "POST",
            "/GetAssociatePayout",
            { ...data },
            {
                onSuccess: (res) => {
                    setPayouts(res?.Response?.AssoPayoutListData);
                    setPreFilter({ formattedFromDate, formattedToDate })
                },
                onStatus3: () => {
                    navigate("/login");
                },
            }
        );
    };
    const convertInMonthsFormat = (input) => {
        const [day, month, year] = input.split("-");
        const months = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        return `${day}-${months[parseInt(month) - 1]}-${year}`
    }
    const calculateTotalCommision = (Arr = [], key) => {
        return Arr?.reduce((crr, item, arr) => crr + Number(item?.[key]), 0)
    }
    return (
        <>
            <div class="content">
                <div class="">
                    <div class="row g-2">
                        <div class="col-auto">
                            <TitleSection text="My Payouts" />
                        </div>
                    </div>
                    <ul class="nav nav-links    mx-n3">
                        <li class="nav-item">
                            <a class="nav-link active" aria-current="page">
                                <span>All </span>
                                <span class="text-body-tertiary fw-semibold">
                                    ({myAllPayouts?.length})
                                </span>
                            </a>
                        </li>
                    </ul>
                    <div
                        id="products"
                        data-list='{"valueNames":["customer","email","total-orders","total-spent","city","last-seen","last-order"],"page":10,"pagination":true}'
                    >
                        <div class="row">
                            <div className="col-12 col-lg-8 col-xl-6">
                                <DateFilterBar onGo={GetAssociatePayout} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div
                                        class="table-responsive scrollbar-overlay mx-n1 px-1 simplebar-mouse-entered"
                                        data-simplebar="init"
                                    >
                                        <div class="simplebar-wrapper" style={{ margin: "0px -4px" }}>
                                            <div class="simplebar-height-auto-observer-wrapper">
                                                <div class="simplebar-height-auto-observer"></div>
                                            </div>
                                            <div class="simplebar-mask">
                                                <div
                                                    class="simplebar-offset"
                                                    style={{ right: "0px", bottom: "0px" }}
                                                >
                                                    <div
                                                        class="simplebar-content-wrapper"
                                                        tabindex="0"
                                                        role="region"
                                                        aria-label="scrollable content"
                                                        style={{ height: "auto", overflow: "hidden" }}
                                                    >
                                                        <div
                                                            class="simplebar-content"
                                                            style={{ padding: "0px 4px" }}
                                                        >
                                                            <div className=" table-responsive">
                                                                <table class="table table-sm fs-9 mb-0">
                                                                    <thead>
                                                                        <tr>
                                                                            <th
                                                                                scope="col"
                                                                                data-sort="customer"
                                                                                style={{ width: "15%" }}
                                                                            >

                                                                                Sr. No.
                                                                            </th>
                                                                            <th
                                                                                scope="col"
                                                                                data-sort="email"
                                                                                style={{ width: "15%" }}
                                                                            >
                                                                                Month.
                                                                            </th>
                                                                            <th
                                                                                onClick={() => handleToggleSorting("email")}
                                                                                scope="col"
                                                                                data-sort="total-orders"
                                                                                style={{ width: "20%" }}
                                                                            >
                                                                                Self Business
                                                                            </th>
                                                                            <th
                                                                                class=" align-middle text-center ps-3"
                                                                                scope="col"
                                                                                data-sort="total-spent"
                                                                                style={{ width: "10%" }}
                                                                            >
                                                                                {/* DOB */}
                                                                                Team Business
                                                                            </th>
                                                                            <th
                                                                                class=" align-middle text-center ps-7"
                                                                                scope="col"
                                                                                data-sort="city"
                                                                                style={{ width: "20%" }}
                                                                            >
                                                                                Self Commission (SBC)
                                                                            </th>
                                                                            <th
                                                                                class=" align-middle text-center"
                                                                                scope="col"
                                                                                data-sort="last-seen"
                                                                                style={{ width: "15%" }}
                                                                            >
                                                                                Team Commission (TBC)
                                                                            </th>
                                                                            <th
                                                                                class=" align-middle text-center"
                                                                                scope="col"
                                                                                data-sort="last-seen"
                                                                                style={{ width: "15%" }}
                                                                            >
                                                                                Total Commission
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody class="list" id="customers-table-body">

                                                                        {myAllPayouts?.length > 0 ?
                                                                            myAllPayouts?.map((item, index) => {
                                                                                return (
                                                                                    <>
                                                                                        <tr
                                                                                            class="hover-actions-trigger btn-reveal-trigger position-static"
                                                                                            key={index}
                                                                                        >
                                                                                            <td class="customer align-middle white-space-nowrap pe-3 fw-bold">
                                                                                                {index + 1}.
                                                                                            </td>
                                                                                            <td class="email align-middle  white-space-nowrap fw-bold">
                                                                                                <Link state={{ payoutNo: item.PayoutNo, backLink: "/my_payouts" }} to={`/my-payouts/my-payout-detail`}>{convertInMonthsFormat(item?.AddedOn)}</Link>
                                                                                            </td>
                                                                                            <td class="email align-middle white-space-nowrap pe-3 ">
                                                                                                <span className=" fw-bold"
                                                                                                >
                                                                                                    {
                                                                                                        convertToINRFormat(item?.SelfBusiness)
                                                                                                    }
                                                                                                </span>
                                                                                                <div><strong>PV:</strong>{parseInt(item?.SelfBusinessPV)}</div>
                                                                                            </td>
                                                                                            <td class="city align-middle white-space-nowrap text-body-highlight ps-7">
                                                                                                <span className=" fw-bold"
                                                                                                > {convertToINRFormat(item?.TeamBusiness)}</span>
                                                                                                <div><strong>PV:</strong>{parseInt(item?.TeamBusinessPV)}</div>
                                                                                            </td>
                                                                                            <td class="  white-space-nowrap   text-center">
                                                                                                <span className=" fw-bold"
                                                                                                >   {convertToINRFormat(item?.SelfIncome)}</span>
                                                                                            </td>
                                                                                            <td class="last-order align-middle white-space-nowrap   text-center">
                                                                                                <span className=" fw-bold"
                                                                                                >  {convertToINRFormat(item?.TeamIncome)}</span>
                                                                                            </td>
                                                                                            <td class="last-order align-middle white-space-nowrap   text-center">
                                                                                                <span className=" fw-bold"
                                                                                                >    {convertToINRFormat(item?.TotalIncome)}</span>
                                                                                            </td>
                                                                                        </tr>
                                                                                        {
                                                                                            myAllPayouts?.length === index + 1 && <tr
                                                                                                style={{ color: "white" }}
                                                                                                className="bg-org text-white"

                                                                                            >
                                                                                                <td className="text-white" colSpan={4} style={{ padding: "10px" }}>
                                                                                                    Total
                                                                                                </td>
                                                                                                <td
                                                                                                    className="text-center text-white"
                                                                                                    style={{ padding: "5px 0" }}
                                                                                                >
                                                                                                    {convertToINRFormat(calculateTotalCommision(myAllPayouts, "SelfIncome"))}
                                                                                                </td>
                                                                                                <td
                                                                                                    className="text-center text-white"
                                                                                                    style={{ padding: "5px 0" }}
                                                                                                >
                                                                                                    {convertToINRFormat(calculateTotalCommision(myAllPayouts, "TeamIncome"))}
                                                                                                </td>
                                                                                                <td
                                                                                                    className="text-center text-white"
                                                                                                    style={{ padding: "5px 0" }}
                                                                                                >
                                                                                                    {convertToINRFormat(calculateTotalCommision(myAllPayouts, "TotalIncome"))}
                                                                                                </td>
                                                                                            </tr>
                                                                                        }
                                                                                    </>
                                                                                );
                                                                            }) : !loading && <td colSpan={6} className=" text-danger text-center fs-7"> Payouts Not Found:)</td>}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {loading && <Loader />}
            </div >
        </>
    );
};

export default MyPayoutsOrg;
